// extracted by mini-css-extract-plugin
export default {"wrapper":"BreadCrumbs_wrapper__hv21b","categoryWrapper":"BreadCrumbs_categoryWrapper__KKb7C","icon":"BreadCrumbs_icon__l9gfK","subPages":"BreadCrumbs_subPages__hgv3U"};